import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../api_config";
import { UserContext } from "../../Components/Authcontext";
import Load from "../Loading/Load";
import "./modern-forms.css";
import axios from "axios";

function ModernBasicInfo() {
  const { user, setUser, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [marital, setMarital] = useState("");
  const [tongue, setTongue] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState(user.userMob || "");
  const [alt, setAlt] = useState("");
  const [age, setAge] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const navigate = useNavigate();

  // Define the form steps
  const totalSteps = 8;
  const currentStep = 1;

  useEffect(() => {
    setMobile(user.userMob || "");
  }, [user]);

  const calculateAge = (dob) => {
    if (dob) {
      const dobDate = new Date(dob);
      if (!isNaN(dobDate)) {
        const currentDate = new Date();
        const userAge = currentDate.getFullYear() - dobDate.getFullYear();
        setAge(userAge);
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setEmailError("Invalid email format");
      return;
    } else {
      setEmailError("");
    }

    // Mobile number validation
    const mobilePattern = /^[0-9]{10}$/;
    if (!mobilePattern.test(mobile)) {
      setMobileError("Invalid mobile number format");
      return;
    } else {
      setMobileError("");
    }
    setLoading(true);
    const dobDate = new Date(dob);
    const currentDate = new Date();
    const userAge = currentDate.getFullYear() - dobDate.getFullYear();
    setAge(userAge);
    const response = await axios.post(
      `${API_BASE_URL}/api/basic-info`,
      {
        user,
        first,
        last,
        dob,
        gender,
        marital,
        tongue,
        email,
        mobile,
        alt,
        age,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    if (response.data.auth) {
      setUser((prevState) => ({ ...prevState, name: response.data.name }));
      setLoading(false);
      navigate("/modern-contact-info", { replace: true });
      setFirst("");
      setLast("");
      setDob("");
      setGender("");
      setMarital("");
      setTongue("");
      setEmail("");
      setAge(null);
    }
  };

  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;

  return loading ? (
    <Load />
  ) : (
    <div className="profile-form-container">
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
      <div className="decoration decoration-4"></div>
      <div className="profile-form-card">
        {/* Form Header with Progress Bar */}
        <div className="profile-form-header">
          <div className="progress-container">
            <div className="progress-steps">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} className="progress-step">
                  <div
                    className={`step-number ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 < currentStep ? "✓" : i + 1}
                  </div>
                  <div
                    className={`step-label ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 === 1 && "Basic Info"}
                    {i + 1 === 2 && "Contact"}
                    {i + 1 === 3 && "Personal"}
                    {i + 1 === 4 && "Photos"}
                    {i + 1 === 5 && "Family"}
                    {i + 1 === 6 && "Lifestyle"}
                    {i + 1 === 7 && "Religious"}
                    {i + 1 === 8 && "Preferences"}
                  </div>
                </div>
              ))}
              <div className="progress-line">
                <div
                  className="progress-line-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <h2 className="profile-form-title">Basic Info</h2>
          <p className="profile-form-subtitle">Tell us about yourself</p>
          <p className="required-fields-note">All fields are mandatory</p>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit}>
          <div className="profile-form-body">
            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">First Name</label>
                  <input
                    className="form-control"
                    type="text"
                    value={first}
                    placeholder="Enter your first name"
                    onChange={(e) => setFirst(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Last Name</label>
                  <input
                    className="form-control"
                    type="text"
                    value={last}
                    placeholder="Enter your last name"
                    onChange={(e) => setLast(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Date of Birth</label>
                  <input
                    className="form-control"
                    type="date"
                    value={dob}
                    onChange={(e) => {
                      setDob(e.target.value);
                      calculateAge(e.target.value);
                    }}
                    required
                  />
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Age</label>
                  <input
                    className="form-control"
                    type="text"
                    value={age}
                    placeholder="Age will be calculated"
                    readOnly
                  />
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Gender</label>
                  <select
                    className="form-control"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="others">Others</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Marital Status</label>
                  <select
                    className="form-control"
                    value={marital}
                    onChange={(e) => setMarital(e.target.value)}
                    required
                  >
                    <option value="">Select Marital Status</option>
                    <option value="Married">Married</option>
                    <option value="UnMarried">Unmarried</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Widower">Widower</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Mother Tongue</label>
              <select
                className="form-control"
                value={tongue}
                onChange={(e) => setTongue(e.target.value)}
                required
              >
                <option value="">Select Mother Tongue</option>
                <option value="Tamil">Tamil</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Telugu">Telugu</option>
                <option value="Kannada">Kannada</option>
                <option value="Hindi">Hindi</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                type="email"
                value={email}
                placeholder="Enter your email address"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {emailError && <div className="error-message">{emailError}</div>}
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Mobile Number</label>
                  <input
                    className="form-control"
                    type="tel"
                    value={mobile}
                    placeholder="Enter your 10-digit mobile number"
                    onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                    required
                  />
                  {mobileError && <div className="error-message">{mobileError}</div>}
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Alternative Number</label>
                  <input
                    className="form-control"
                    type="tel"
                    value={alt}
                    placeholder="Enter alternative number (optional)"
                    onChange={(e) => setAlt(e.target.value.replace(/\D/g, ""))}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Form Footer with Buttons */}
          <div className="profile-form-footer">
            <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
              Back
            </button>
            <button type="submit" className="btn btn-primary">
              Save & Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModernBasicInfo;
